export default __webpack_public_path__ + "static/media/ic-swapped-coin.62d85d91.svg";